import { async } from '@angular/core/testing';
export const appConfigMapping = {
  security: {
    securityDomains: (window as any).appConfig.security.securityDomains,
    clientId: (window as any).appConfig.security.clientId,
    autoConfigUrl: (window as any).appConfig.security.autoConfigUrl
  },
  appVersion: (window as any).appConfig.appVersion,
  api: {
    atamUrl: (window as any).appConfig.api.atamUrl,
    logoutUrl: (window as any).appConfig.api.logoutUrl
  },  
  featureFlags: {
    hideAdditionalLimits: (window as any).appConfig.featureFlags.hideAdditionalLimits,
  },
  googleAnalyticsTrackingId: (<any>window).appConfig.googleAnalyticsTrackingId,
  googleAnalyticsURL: (<any>window).appConfig.googleAnalyticsURL,
  rum: (<any>window).appConfig.rum
};
